import React from "react";
import { isEqual } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import { useAISummary } from "@radarly/core/ai/use-cases";
// import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { FailureReasons, isFailedSubAnalysisSummary } from "@radarly/models/ai";
import { AICard } from "@radarly/models/cards/model";
import { Project } from "@radarly/models/project";
import Loading from "../loading";
import Inner from "./inner";
import ReloadFromAIGenerationIssueOverlay from "./reload-overlay";

interface IProps {
  fragments: AICard["fragments"];
  dataviz: AICard["dataviz"];
  project: Project;
  forceReload?: boolean;
  overflowTitleCard?: boolean;
  isAlreadyOverlay?: boolean;
  previousLocale?: Locale;
}

export default function SharedWidgetsAI({
  fragments,
  project,
  forceReload,
  overflowTitleCard,
  isAlreadyOverlay,
  previousLocale,
}: IProps) {
  const { data, isFetching, isError, refetch } = useAISummary(
    project.id,
    fragments[0],
    previousLocale
  );

  const isSummaryGenerationIssue =
    data &&
    Object.values(data).length > 0 &&
    Object.values(data).every(
      (subAnalysis) =>
        !subAnalysis ||
        (isFailedSubAnalysisSummary(subAnalysis) &&
          subAnalysis.reason === FailureReasons.AIFailure)
    );

  const locale = useCurrentUserLocale();
  const isDifferentLocale = !isEqual(locale, previousLocale);

  return (
    <Loading loading={isFetching} forceReload={forceReload}>
      <ReloadFromAIGenerationIssueOverlay
        locale={locale}
        needReload={
          !isAlreadyOverlay &&
          ((!isFetching && isSummaryGenerationIssue) || isError)
        }
        onClickReload={refetch}
        overflowTitleCard={overflowTitleCard}
      />
      {!isFetching && !isDifferentLocale && !isError && (
        <Inner data={data} aiType={fragments?.[0]?.analysis.type} />
      )}
    </Loading>
  );
}
